export function calculateDose(weeklyAmt, frequency, concentration) {
  const result = weeklyAmt / frequency / concentration;

  return parseFloat(result.toFixed(6));
}

export function formatFrequency(frequency) {
  if (frequency > 1) {
    return `${frequency} times per week`;
  } else {
    return `${frequency} time per week`;
  }
}

export function computeSlin(ml) {
  let unit = 0.01;
  let result = ml / unit;
  return parseFloat(result.toFixed(4));
}
